const ProjectsSearchEmpty = ({ query, onClear }) => {
  return (
    <div className="projects-search-empty">
      <div className="projects-search-empty-title">No matching projects</div>
      <div className="projects-search-empty-text">No projects match “{query}”.</div>
      <button className="projects-search-empty-clear" onClick={() => onClear('')}>
        Clear search
      </button>
    </div>
  );
};
export default ProjectsSearchEmpty;
